import { useAppSelector } from "src/hooks/redux";
import DatePicker from "../datepicker/datepicker";
import { selectItems } from "src/modules/vpo/selectors/selectItems";
import { TooltipItem } from "src/utils/Tooltip";
import WarningIcon from "src/components/ui-icons/myTasks/WarningIcon";

import { StatusQuestionnaire } from "../../types/data";

type ChoosingMonthProps = {
  year: number;
  setYear: React.Dispatch<React.SetStateAction<number | null>>;
  month: number;
  setMonth: React.Dispatch<React.SetStateAction<number | null>>;
  statusQuestionnaire?: StatusQuestionnaire;
  currentDate: unknown;
  isNotAction?: boolean;
  custom?: boolean;
};

function ChoosingMonth({ year, setYear, month, setMonth, statusQuestionnaire, isNotAction, currentDate, custom }: ChoosingMonthProps) {
  const getColor = (param: StatusQuestionnaire) => {
    if (param === 'Не начато') return '#8899A8';
    if (param === 'В процессе') return '#F2A900';
    if (param === 'Завершено') return '#22AD5C';
  };

  return (
    <div className="flex grow justify-center items-center gap-4 rounded-md p-4 shadow-md bg-white">
      <DatePicker
        year={year}
        setYear={setYear}
        month={month}
        setMonth={setMonth}
        isSummary={custom as boolean}
        currentDate={currentDate}
      />

      {!custom && statusQuestionnaire && (
        <div className="flex items-center gap-2">
          <div className='h-2 w-2 rounded-full' style={{backgroundColor: getColor(statusQuestionnaire)}} />
          <div style={{color: getColor(statusQuestionnaire)}}>{statusQuestionnaire}</div>
        </div>
      )}

      {!custom && isNotAction && statusQuestionnaire === 'Завершено' && (
        <TooltipItem position="top" tooltipsText={'У некоторых ответов "Нет" отсутствуют запланированные действия'}>
          <span className="text-rose-600">
            <WarningIcon aria-hidden="true" />
          </span>
        </TooltipItem>
      )}
    </div>
  );
}

export default ChoosingMonth;
